import React from "react"
import { Link } from "gatsby"
import { graphql } from "gatsby"
import { BgImage } from "gbimage-bridge"
import ReactMarkdown from "react-markdown"
import { GatsbyImage } from "gatsby-plugin-image";
import TopMenu from "../components/TopMenu"
import BookDemo from "../components/BookDemo"
import Footer from "../components/Footer"
import Seo from "../components/Seo"
import Testimonial from "../components/testimonials/Testimonial"
import VideoButton from "../components/VideoButton"

export default function PageScanners({data}) {
  const page = data.strapiPageScanners;
  const { image, title, subtitle } = page.info;
  const products = data.allStrapiProducts.nodes;
  const bookDemo = page.bookDemo;
  // console.warn(page);

  return (
    <div className="">
    <Seo 
      title={(page.seo && page.seo.title) ? page.seo.title : page.title}
      description={(page.seo && page.seo.description) ? page.seo.description : undefined }
      />
        <BgImage image={image.childImageSharp.gatsbyImageData} className="gs-bg-parallax"></BgImage>
        <TopMenu />

        <div className="gs-page-hero gs-scanners-hero">
        <BgImage image={page.heroImage.childImageSharp.gatsbyImageData} style={{"backgroundSize": "contain", "backgroundPosition": "center center", "backgroundColor": "#000000" }}>
            <div className="gs-page-hero__in gs-sect__in gs-scanners-hero__in">
              <div className="gs-container">
                <header className="gs-page-header tac">
                    <h1 className="gs-header-msg--mark mb05">{ title }</h1>
                    <div className="gs-products-item__hr dib"></div>
                    <h5 className="fw300">{ subtitle }</h5>
                </header>
              </div>
            </div>
          </BgImage>
          </div>

        <section className="gs-solution gs-color-contrast gs-products-item gs-bg-1">
          <div className="gs-sect__in gs-container gs-container--900">
            <header className="tac mb3">
            <ReactMarkdown source={page.introText} escapeHtml={false}/>
            </header>            
            <ul className="gs-features" style={{ "--sal-duration": "1s" }}>
            {
              page.features.map((feature, i)=>{
                return (
                  <li key={feature.id} className={"gs-scanners-features-item gs-features-item gs-features-item--"+(i+1)} data-sal="slide-up">
                  <img
                      src={feature.icon.publicURL}
                      alt={feature.name}
                      className="gs-features__icon"
                      data-sal="zoom-in"
                    />
                    <h4>{feature.name}</h4>
                    {/* <p className="gs-features-item__caption">
                      {feature.desc}
                    </p> */}
                  </li>
                )
              })
            }
            </ul>
            </div>
        </section>

        <section className="gs-section-angular gs-section-angular--2">
              <div className="gs-sect__in gs-container ovh">
              <header className="tac mb4">
                    <h2 className="mb05">THE OCUS SERIES</h2>
                    <div className="gs-products-item__hr dib"></div>
              </header>
              <div className="gs-product-list jcc">
              {
                products.map((product)=>{
                  return (
                    <div key={product.id} className="gs-product gs-product--vertical tac">
                      <Link to={"/"+product.slug}
                        className="gs-product-pic gs-products-item-pic mb2 tac"
                        data-sal="zoom-in" data-sal-duration="1000"
                      >
                        <GatsbyImage
                          image={product.imageAlt2.childImageSharp.gatsbyImageData}
                          alt={product.title}
                          className="gs-products-item__img" />
                      </Link>
                      <div
                        className="gs-products-item-content tac"
                        data-sal="slide-up" 
                        data-sal-duration="1000"
                      >
                        <h3 className="gs-products-item__title">
                          {product.title}
                        </h3>
                        <div className="gs-products-item__hr"></div>
                        <p className="mb3">
                          {product.descriptionShort}
                        </p>
                        <div className="gs-products-item-actions">
                          <Link to={"/"+product.slug} className="gs-button gs-color-contrast mr1 mb1">
                            Learn more
                          </Link>
                          {
                            product.videoCodeOverview && <VideoButton youtubeId={product.videoCodeOverview}>WATCH VIDEO</VideoButton>
                          }
                        </div>
                      </div>
                    </div>
                  );
                })
              }

              </div>
                
              </div>
            </section>

            <article className="gs-products-item">
              <BookDemo
                title={bookDemo.title}
                text={bookDemo.text}
                cta={bookDemo.buttonText}
              />
            </article>

        <section className="gs-products">
          <div className="gs-bg-parallax__wrap">
            <div className="gs-sect__in gs-container">
            <ul className="gs-features gs-scanner-features--2" style={{ "--sal-duration": "1s" }}>
            {
              page.features.map((feature, i)=>{
                return (
                  <li key={feature.id} className={"gs-scanners-features-item gs-features-item gs-features-item--"+(i+1)} data-sal="slide-up">
                    <h4>{feature.name}</h4>
                    <p className="gs-features-item__caption">
                      {feature.desc}
                    </p>
                  </li>
                )
              })
            }
            </ul>
            </div>
            <article className="gs-products-item gs-products-item--last">
              <div className="gs-sect__in gs-container ovh">
                <Testimonial selected={7} className="clean mb2"></Testimonial>
              </div>
            </article>
            <Footer/>
          </div>
        </section>
      </div>
  );
}

export const query = graphql`
  {
    allStrapiProducts(filter: { active: { eq: true } }) {
      nodes {
        id
        imageAlt2 {
          childImageSharp {
            gatsbyImageData(
              width: 600
              layout: CONSTRAINED
              placeholder: BLURRED
            )
          }
        }
        subtitle
        slug
        title
        descriptionShort
        videoCodeOverview
      }
    }
    strapiPageScanners {
      id
      seo {
        title
        description
      }
      info {
        title
        subtitle
        slug
        image {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
        }
      }
      introText
      heroImage {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      features {
        id
        desc
        name
        icon {
          publicURL
        }
      }
      bookDemo {
        title
        text
        buttonText
      }
    }
  }
`